// This file is auto-generated - DO NOT EDIT - it will be overwritten. 

export const allRoutes = {
	Dashboard:() => { return `/dashboard` },
	ExternalWorkorder:(guid) => { return `/external/workorder/${guid}` },
	NewsList:() => { return `/news/list` },
	NewsListRead:(id) => { return `/news/list/read/${id}` },
	NewsAdmin:() => { return `/news/admin` },
	NewsAdminAdd:() => { return `/news/admin/add` },
	NewsAdminEdit:(id) => { return `/news/admin/edit/${id}` },
	LearningUser:() => { return `/learning/user` },
	LearningUserExamsDetails:(id) => { return `/learning/user/exams/${id}/details` },
	LearningUserExamsExamination:(id) => { return `/learning/user/exams/${id}/examination` },
	LearningUserExamsFinished:(id,resultId) => { return `/learning/user/exams/${id}/finished/${resultId}` },
	LearningAdmin:() => { return `/learning/admin` },
	LearningAdminExamsDetails:(id) => { return `/learning/admin/exams/${id}/details` },
	LearningAdminResults:() => { return `/learning/admin/results` },
	LearningAdminResultsDetails:(id) => { return `/learning/admin/results/${id}/details` },
	Planning:() => { return `/planning` },
	PlanningSchedule:() => { return `/planning/schedule` },
	PlanningAssignment:() => { return `/planning/assignment` },
	PlanningEcodriving:() => { return `/planning/ecodriving` },
	IssuereportsDashboard:() => { return `/issuereports/dashboard` },
	IssuereportsArchive:() => { return `/issuereports/archive` },
	IssuereportsArchiveIssuereport:(id) => { return `/issuereports/archive/issuereport/${id}` },
	IssuereportsWorkorders:() => { return `/issuereports/workorders` },
	IssuereportsWorkordersAdd:() => { return `/issuereports/workorders/add` },
	IssuereportsWorkordersDetails:(id) => { return `/issuereports/workorders/details/${id}` },
	IssuereportsArchiveCategories:() => { return `/issuereports/archive/categories` },
	Deviation:() => { return `/deviation` },
	DeviationList:() => { return `/deviation/list` },
	DeviationListCreate:() => { return `/deviation/list/create` },
	DeviationListDetails:(id) => { return `/deviation/list/details/${id}` },
	Reports:() => { return `/reports` },
	ReportsVehiclereports:() => { return `/reports/vehiclereports` },
	ReportsVehiclereportsReporttemplates:() => { return `/reports/vehiclereports/reporttemplates` },
	ReportsVehiclereportsReporttemplatesAdd:() => { return `/reports/vehiclereports/reporttemplates/add` },
	ReportsVehiclereportsReporttemplatesEdit:(id) => { return `/reports/vehiclereports/reporttemplates/edit/${id}` },
	ReportsVehiclereportsFueldata:() => { return `/reports/vehiclereports/fueldata` },
	ReportsVehiclereportsFueldataImport:() => { return `/reports/vehiclereports/fueldata/import` },
	ReportsVehiclereportsContract:() => { return `/reports/vehiclereports/contract` },
	ReportsVehiclereportsContractImport:() => { return `/reports/vehiclereports/contract/import` },
	ReportsVehiclereportsContractEdit:(id) => { return `/reports/vehiclereports/contract/edit/${id}` },
	ReportsVehiclereportsContractAdd:() => { return `/reports/vehiclereports/contract/add` },
	ReportsUserreports:() => { return `/reports/userreports` },
	ReportsUserreportsReporttemplates:() => { return `/reports/userreports/reporttemplates` },
	ReportsUserreportsReporttemplatesAdd:() => { return `/reports/userreports/reporttemplates/add` },
	ReportsUserreportsReporttemplatesEdit:(id) => { return `/reports/userreports/reporttemplates/edit/${id}` },
	ReportsUserreportsBkychecks:() => { return `/reports/userreports/bkychecks` },
	Violation:() => { return `/violation` },
	ViolationDetails:(id) => { return `/violation/details/${id}` },
	ViolationAdmin:() => { return `/violation/admin` },
	Vehiclealarm:() => { return `/vehiclealarm` },
	VehiclealarmSettings:() => { return `/vehiclealarm/settings` },
	VehicleregistryDashboard:() => { return `/vehicleregistry/dashboard` },
	VehicleregistryVehicles:() => { return `/vehicleregistry/vehicles` },
	VehicleregistryChecks:() => { return `/vehicleregistry/checks` },
	VehicleregistryCalendar:() => { return `/vehicleregistry/calendar` },
	VehicleregistryVehiclesDetails:(id) => { return `/vehicleregistry/vehicles/${id}/details` },
	VehicleregistrySettings:() => { return `/vehicleregistry/settings` },
	VehicleregistryVehiclesImport:() => { return `/vehicleregistry/vehicles/import` },
	VehicleregistryVehiclesImportvtr:() => { return `/vehicleregistry/vehicles/importvtr` },
	Map:() => { return `/map` },
	Documents:() => { return `/documents` },
	DocumentsDetails:(id) => { return `/documents/details/${id}` },
	DocumentsEdit:(id) => { return `/documents/edit/${id}` },
	Assembly:() => { return `/assembly` },
	Payslip:() => { return `/payslip` },
	CustomerSettingsCustomer:() => { return `/customer/settings/customer` },
	CustomerSettingsCompanies:() => { return `/customer/settings/companies` },
	CustomerSettingsCompaniesAdd:() => { return `/customer/settings/companies/add` },
	CustomerSettingsCompaniesEdit:(id) => { return `/customer/settings/companies/edit/${id}` },
	CustomerSettingsUsers:() => { return `/customer/settings/users` },
	CustomerSettingsUsersAdd:() => { return `/customer/settings/users/add` },
	CustomerSettingsUsersEdit:(id) => { return `/customer/settings/users/edit/${id}` },
	CustomerSettingsUsersEditPasswordreset:(id) => { return `/customer/settings/users/edit/${id}/passwordreset` },
	CustomerSettingsUsersCustomfields:() => { return `/customer/settings/users/customfields` },
	SystemadminCustomers:() => { return `/systemadmin/customers` },
	SystemadminCustomersAdd:() => { return `/systemadmin/customers/add` },
	SystemadminCustomersEdit:(id) => { return `/systemadmin/customers/edit/${id}` },
	SystemadminCustomersEditCustomer:(id) => { return `/systemadmin/customers/edit/${id}/customer` },
	SystemadminCustomersEditCompanies:(id) => { return `/systemadmin/customers/edit/${id}/companies` },
	SystemadminCustomersEditCompaniesAdd:(id) => { return `/systemadmin/customers/edit/${id}/companies/add` },
	SystemadminCustomersEditCompaniesEdit:(id,companyId) => { return `/systemadmin/customers/edit/${id}/companies/edit/${companyId}` },
	SystemadminCustomersEditUsers:(id) => { return `/systemadmin/customers/edit/${id}/users` },
	SystemadminCustomersEditUsersAdd:(id) => { return `/systemadmin/customers/edit/${id}/users/add` },
	SystemadminCustomersEditUsersEdit:(id,userId) => { return `/systemadmin/customers/edit/${id}/users/edit/${userId}` },
	SystemadminCustomersEditUsersEditPasswordreset:(id,userId) => { return `/systemadmin/customers/edit/${id}/users/edit/${userId}/passwordreset` },
	SystemadminCustomersEditUsersImport:(id) => { return `/systemadmin/customers/edit/${id}/users/import` },
	SystemadminCustomersEditUsersImportlegacyexams:(id) => { return `/systemadmin/customers/edit/${id}/users/importlegacyexams` },
	SystemadminLearning:() => { return `/systemadmin/learning` },
	SystemadminLearningExamDetails:(id) => { return `/systemadmin/learning/exam/${id}/details` },
	SystemadminDevices:() => { return `/systemadmin/devices` },
	SystemadminDevicesRegister:() => { return `/systemadmin/devices/register` },
	SystemadminDevicesRegisterAdd:() => { return `/systemadmin/devices/register/add` },
	SystemadminDevicesRegisterEdit:(id) => { return `/systemadmin/devices/register/edit/${id}` },
	SystemadminDevicesEquipment:() => { return `/systemadmin/devices/equipment` },
	SystemadminDevicesEquipmentAdd:() => { return `/systemadmin/devices/equipment/add` },
	SystemadminDevicesEquipmentEdit:(id) => { return `/systemadmin/devices/equipment/edit/${id}` },
	SystemadminDevicesStorage:() => { return `/systemadmin/devices/storage` },
	SystemadminDevicesStorageAdd:() => { return `/systemadmin/devices/storage/add` },
	SystemadminDevicesStorageEdit:(id) => { return `/systemadmin/devices/storage/edit/${id}` },
	SystemadminDevicesTechnicalpackage:() => { return `/systemadmin/devices/technicalpackage` },
	SystemadminDevicesSystemevents:() => { return `/systemadmin/devices/systemevents` },
	SystemadminSystemEvents:() => { return `/systemadmin/system/events` },
	CrisismanagementCrisisinfo:() => { return `/crisismanagement/crisisinfo` },
	UserSettings:() => { return `/user/settings` },
	UserSettingsPasswordchange:() => { return `/user/settings/passwordchange` },
}
